import { GlobalState, UI } from '@leverege/ui-redux';
const THIRTY_SECONDS = 1000 * 30;
const USER_POSITION_SUCCESS_EVENT_TYPE = 'position';
const USER_POSITION_ERROR_EVENT_TYPE = 'error';
class UserPosition {
  constructor() {
    this.events = {
      position: new Set(),
      error: new Set()
    };
    this.watchId = null;

    // Not sure that this needs to be configurable
    this.positionOptions = {
      enableHighAccuracy: true,
      maximumAge: THIRTY_SECONDS,
      timeout: THIRTY_SECONDS
    };
  }
  startWatchingPosition() {
    this.watchId = navigator.geolocation.watchPosition(this.onPositionSuccess, this.onPositionError, this.positionOptions);
  }
  stopWatchingPosition() {
    navigator.geolocation.clearWatch(this.watchId);
    this.watchId = null;
  }
  async getPositionImmediate() {
    GlobalState.dispatch(UI.set('position/loading', true));
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(evt => {
        this.setPositionAuthorized();
        resolve(evt);
      }, err => {
        this.setPositionDenied(err);
        reject(err);
      }, this.positionOptions);
    });
  }
  setPositionAuthorized = () => {
    const authorized = UI.get(GlobalState.get()).position?.authorized;
    const update = {
      'position/loading': false
    };
    if (!authorized) {
      update['position/authorized'] = true;
    }
    GlobalState.dispatch(UI.multiSet(update));
  };
  setPositionDenied = err => {
    const authorized = UI.get(GlobalState.get()).position?.authorized;
    const update = {
      'position/loading': false
    };
    if (authorized !== false && err.code === 1) {
      update['position/authorized'] = false;
    }
    GlobalState.dispatch(UI.multiSet(update));
  };
  onPositionSuccess = evt => {
    this.setPositionAuthorized();
    this.fireEvent(evt, USER_POSITION_SUCCESS_EVENT_TYPE);
  };
  onPositionError = err => {
    this.setPositionDenied(err);
    this.fireEvent(err, USER_POSITION_ERROR_EVENT_TYPE);
  };
  addListener(event, l) {
    if (typeof l !== 'function' || this.events[event] == null) {
      return;
    }
    const listeners = this.events[event];
    listeners.add(l);
    setTimeout(() => {
      GlobalState.dispatch(UI.set('position/loading', true));
      if (this.watchId == null) {
        this.startWatchingPosition();
      }
      this.getPositionImmediate().then(l);
    }, 1);
  }
  removeListener(event, l) {
    if (this.events[event] == null) {
      return;
    }
    const listeners = this.events[event];
    listeners.delete(l);
    if (event === USER_POSITION_SUCCESS_EVENT_TYPE && listeners.size === 0) {
      setTimeout(() => {
        this.stopWatchingPosition();
      }, 1);
    }
  }
  fireEvent(evt, type) {
    const listeners = this.events[type];
    listeners.forEach(listener => {
      listener(evt);
    });
  }
}
const instance = new UserPosition();
export default instance;